export default [
  {
    id: 0,
    name: 'total_mrr',
    description: 'Ingresos mensuales recurrentes totales obtenidos de las suscripciones.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'MRR',
    active: true
  },
  {
    id: 1,
    name: 'expansion_mrr',
    description: 'Adición a los ingresos recurrentes mensuales de las suscripciones existentes.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'MRR',
    active: true
  },
  {
    id: 2,
    name: 'new_mrr',
    description: 'Ingresos mensuales recurrentes obtenidos por nuevas suscripciones adquiridas durante el período.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'MRR',
    active: true
  },
  {
    id: 3,
    name: 'contraction_mrr',
    description: 'Disminución de los ingresos recurrentes mensuales de las suscripciones existentes.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        colors: ['#B71C1C'],
        backgroundColor: 'rgba(205, 92, 92, 0.2)',
        class: 'line'
      }
    },
    currency: true,
    category: 'MRR',
    active: true
  },
  {
    id: 4,
    name: 'churn_mrr',
    description: 'Ingresos mensuales recurrentes perdidos por cancelaciones durante el período.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'MRR',
    active: true
  },
  {
    id: 6,
    name: 'net_growth_mrr',
    description: 'Aumento o disminución neto de los ingresos recurrentes mensuales durante el período.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        labels: ['Nuevo', 'Expansión', 'Contracción', 'Abandono', 'Crecimiento neto'],
        colors: ['#3F51B5', '#9FA8DA', '#FFECB3', '#FFC107', '#1A237E'],
        class: 'barStacked'
      }
    },
    currency: true,
    category: 'MRR',
    active: true
  },
  {
    id: 9,
    name: 'arpu',
    description: 'Los ingresos promedio obtenidos por suscripciones por mes.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'Suscripciones',
    active: true
  },
  {
    id: 10,
    name: 'total_arr',
    description: 'Ingresos anuales recurrentes totales obtenidos de las suscripciones.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'ARR',
    active: true
  },
  {
    id: 11,
    name: 'expansion_arr',
    description: 'Adición a los ingresos recurrentes anuales de las suscripciones existentes.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'ARR',
    active: true
  },
  {
    id: 12,
    name: 'new_arr',
    description: 'Ingresos anuales recurrentes obtenidos por nuevas suscripciones adquiridas durante el período.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'ARR',
    active: true
  },
  {
    id: 13,
    name: 'contraction_arr',
    description: 'Disminución de los ingresos recurrentes anuales de las suscripciones existentes.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        colors: ['#B71C1C'],
        backgroundColor: 'rgba(205, 92, 92, 0.2)',
        class: 'line'
      }
    },
    currency: true,
    category: 'ARR',
    active: true
  },
  {
    id: 14,
    name: 'churn_arr',
    description: 'Ingresos anuales recurrentes perdidos por cancelaciones durante el período.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'ARR',
    active: true
  },
  {
    id: 15,
    name: 'net_growth_arr',
    description: 'Aumento o disminución neto de los ingresos recurrentes anuales durante el período.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        labels: ['Nuevo', 'Expansión', 'Contracción', 'Abandono', 'Crecimiento neto'],
        colors: ['#3F51B5', '#9FA8DA', '#FFECB3', '#FFC107', '#1A237E'],
        class: 'barStacked'
      }
    },
    currency: true,
    category: 'ARR',
    active: true
  },
  {
    id: 16,
    name: 'total_cancelled_subscription',
    description: 'Número total de cancelación de suscripciones hasta la fecha.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        colors: ['#B71C1C'],
        backgroundColor: 'rgba(205, 92, 92, 0.2)',
        class: 'line'
      }
    },
    currency: false,
    category: 'Suscripciones',
    active: true
  },
  {
    id: 20,
    name: 'rate_cancelled_subscription',
    description: 'Porcentaje de suscripciones canceladas durante el período.',
    type: {
      kpi: {
        displayComparative: true
      }
    },
    currency: false,
    category: 'Suscripciones',
    active: true
  },
  {
    id: 22,
    name: 'total_billing',
    description: 'Valor total de las facturas generadas durante el período.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'Facturación',
    active: true
  },
  {
    id: 26,
    name: 'total_billing_non_recurring',
    description: 'Ingresos no recurrentes totales facturados en un período en particular.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'Facturación',
    active: true
  },
  {
    id: 27,
    name: 'total_tax',
    description: 'Total de impuestos aplicados a las facturas durante el período de tiempo.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'Impuestos',
    active: true
  },
  {
    id: 28,
    name: 'total_cancelled_billing',
    description: 'Valor total de todas las facturas anuladas durante el período.',
    type: {
      kpi: {
        append: 'CLP',
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'Facturación',
    active: true
  },
  {
    id: 29,
    name: 'net_billing',
    description: 'Valor total de las facturas después de excluir el valor de las notas de crédito emitidas y los impuestos.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'Facturación',
    active: true
  },
  {
    id: 30,
    name: 'total_receivables_overdue',
    description: 'Total por cobrar de facturas que han superado la fecha de vencimiento del pago.',
    type: {
      kpi: {
        displayComparative: false
      }
    },
    currency: true,
    category: 'Cobranza',
    active: true
  },
  {
    id: 31,
    name: 'total_receivables_current_due',
    description: 'Total por cobrar de facturas que no han superado la fecha de vencimiento.',
    type: {
      kpi: {
        displayComparative: false
      }
    },
    currency: true,
    category: 'Cobranza',
    active: true
  },
  {
    id: 32,
    name: 'overdue_billing_recovery_breakdown',
    description: 'Agrupación de facturas no pagadas según el número de días vencidos.',
    type: {
      table: {
        headers: [
          { text: 'Días', value: 'label', class: 'font-weight-bold', sortable: false },
          { text: 'Número de facturas', value: 'count', class: 'font-weight-bold', align: 'end', sortable: false },
          { text: 'Monto total', value: 'data', class: 'font-weight-bold', align: 'end', sortable: false }
        ],
        formats: {
          label: 'id',
          count: 'quantity',
          data: 'currency'
        },
        link: false
      }
    },
    currency: false,
    category: 'Cobranza',
    active: true
  },
  {
    id: 70,
    name: 'total_receivables',
    description: 'Total por cobrar de facturas no vencidas y vencidas.',
    type: {
      kpi: {
        displayComparative: false
      }
    },
    currency: true,
    category: 'Cobranza',
    active: true
  },
  {
    id: 71,
    name: 'customer_debtor',
    description: 'Indice de clientes con mayor deuda.',
    type: {
      table: {
        headers: [
          { text: 'Cliente', value: 'label', class: 'font-weight-bold', sortable: false },
          { text: 'Número de facturas', value: 'count', class: 'font-weight-bold', align: 'end', sortable: false },
          { text: 'Deuda total (balance)', value: 'data', class: 'font-weight-bold', align: 'end', sortable: false }
        ],
        formats: {
          label: 'text',
          count: 'quantity',
          data: 'currency'
        },
        link: 'CustomerRetrieveUpdate'
      }
    },
    currency: false,
    category: 'Cobranza',
    active: true
  },
  {
    id: 72,
    name: 'total_payments',
    description: 'Total de transacciones exitosas recibidas.',
    type: {
      graph: {
        class: 'line',
        metrics: [
          { metric: 'single_payments', group: false, sum: true },
          { metric: 'recurrent_payments', group: false, sum: true }
        ]
      }
    },
    currency: true,
    category: 'Cobranza',
    active: true
  },
  {
    id: 73,
    name: 'transactions_received_by_gateway',
    description: 'Total de transacciones exitosas recibidas agrupadas por procesador de pagos.',
    type: {
      graph: {
        class: 'bar',
        colors: [
          { color: '#8e24aa', label: 'stripe' },
          { color: '#03A9F4', label: 'ach_transfer' },
          { color: '#009688', label: 'offline_payment' },
          { color: '#f06292', label: 'webpay' },
          { color: '#6d4c41', label: 'getnet' },
          { color: '#00acc1', label: 'mercadopago' },
          { color: '#b71c1c', label: 'getnetclick' },
          { color: '#00acc1', label: 'oneclick' },
          { color: '#3949ab', label: 'current' }
        ],
        metrics: [
          { metric: 'single_payments', group: true },
          { metric: 'recurrent_payments', group: true },
          { metric: 'single_payments', group: false, sum: true },
          { metric: 'recurrent_payments', group: false, sum: true }
        ],
        lastAsSum: true
      }
    },
    currency: true,
    category: 'Cobranza',
    active: true
  },
 {
    id: 74,
    name: 'unused-supporting-documents',
    description: 'Número total de documentos de soporte no utilizados a la fecha.',
    type: {
      kpi: {
        displayComparative: false
      }
    },
    currency: false,
    category: 'Documentos de soporte',
    actions: [{
      label: 'Ver documentos',
      goTo: {
        name: 'SupportingDocumentListCreate',
        query: {
          used: 'False'
        }
      }
    }],
    active: true
  },
  {
    id: 75,
    name: 'unprocessed-subscriptions',
    description: 'Número total de suscripciones que no han sido procesadas y requieren atención por motivos de documento de soporte.',
    type: {
      kpi: {
        displayComparative: false
      }
    },
    currency: false,
    category: 'Documentos de soporte',
    actions: [{
      label: 'Ver suscripciones',
      goTo: {
        name: 'SubscriptionList',
        query: {
          status: 'needs_attention',
          needs_attention_reason__in: 'reference_expired,without_reference'
        }
      }
    }],
    active: true
  },
  {
    id: 76,
    name: 'expired-supporting-documents',
    description: 'Número total de documentos de soporte expirados.',
    type: {
      kpi: {
        displayComparative: false
      }
    },
    currency: false,
    category: 'Documentos de soporte',
    actions: [{
      label: 'Ver documentos',
      goTo: {
        name: 'SupportingDocumentListCreate',
        query: {
          is_expired: 'True'
        }
      }
    }],
    active: true
  }
]
